<template>
  <div class="app-content content" style="margin: 0; padding: 30px;">
    <div class="content-overlay"></div>
    <div class="content-wrapper">
      <div class="content-header row"></div>
      <div class="content-body">
        <div class="auth-wrapper auth-cover">
          <div class="auth-inner row m-0">
            <div class="d-none d-lg-flex col-md-6 align-items-center">
              <div class="w-100 d-lg-flex align-items-center justify-content-center">
                <img class="img-fluid" src="app-assets/images/login-v2.svg" alt="Staff Register" />
              </div>
            </div>

            <div class="d-flex col-md-6 align-items-center auth-bg px-2 p-lg-5">
              <div class="col-md-12 mx-auto pt-2 mobile-login">
                <div style="margin-left: -15px;">
                  <a class="nav-link" href="/"><img src="app-assets/images/brand-logo.png" style="height: 45px;"></a>
                </div>
                <p class="card-text mb-2">Staff Registration</p>
                <h3 style="color: #e35858"><b>{{ errMessage }}</b></h3>

                <div class="mb-1">
                  <label class="form-label">User ID</label>
                  <input
                    class="form-control"
                    type="text"
                    v-model="serialNo"
                    :disabled="validated"
                    placeholder="Enter your User ID"
                    autofocus
                  />
                </div>

                <button
                  v-if="!validated"
                  class="btn btn-primary w-100 mt-1"
                  :disabled="loading"
                  @click="onNext"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm text-white" role="status" aria-hidden="true"></span>
                  Next
                </button>

                <form v-if="validated" class="mt-2" @submit.prevent="onRegister">
                  <div class="mb-1">
                    <label class="form-label">Mobile Number <small class="text-muted">(optional)</small></label>
                    <input class="form-control" type="text" v-model="formData.mobile" placeholder="Enter mobile number" />
                  </div>
                  <div class="mb-1">
                    <label class="form-label">Password</label>
                    <input class="form-control" type="password" v-model="formData.password" placeholder="············" />
                  </div>
                  <div class="mb-1">
                    <label class="form-label">Confirm Password</label>
                    <input class="form-control" type="password" v-model="formData.password_confirmation" placeholder="············" />
                  </div>
                  <button class="btn btn-primary w-100" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm text-white" role="status" aria-hidden="true"></span>
                    Register
                  </button>
                </form>

                <p class="text-center mt-2">
                  Already have an account?
                  <router-link to="login"><span>&nbsp;Sign in</span></router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, ref } from 'vue'
import handleSdm from '@/services/modules/sdm/sdm'
import handleLogin from '@/services/modules/login'

const showError = inject('showError')
const showSuccess = inject('showSuccess')
const { staffRegisterVerify, staffRegisterStore } = handleSdm()
const { setUserInLocalStorage, setTokenInLocalStorage, setPublicTokenInLocalStorage } = handleLogin()

const loading = ref(false)
const validated = ref(false)
const errMessage = ref('')
const serialNo = ref('')
const formData = ref({
  mobile: '',
  password: '',
  password_confirmation: '',
})

const onNext = async () => {
  errMessage.value = ''
  if (!serialNo.value) {
    errMessage.value = 'Please enter your User ID'
    return
  }
  try {
    loading.value = true
    const res = await staffRegisterVerify({ user_id: serialNo.value })
    if (!res.status) {
      errMessage.value = res.message
      return
    }
    validated.value = true
  } catch (err) {
    errMessage.value = err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Something went wrong'
  } finally {
    loading.value = false
  }
}

const onRegister = async () => {
  errMessage.value = ''
  try {
    loading.value = true
    const res = await staffRegisterStore({
      user_id: serialNo.value,
      mobile: formData.value.mobile,
      password: formData.value.password,
      password_confirmation: formData.value.password_confirmation,
    })
    if (!res.status) {
      errMessage.value = res.message
      return
    }
    showSuccess(res.message)
    setUserInLocalStorage(res.data)
    setTokenInLocalStorage(res.access_token)
    setPublicTokenInLocalStorage(res.public_access_token)
    localStorage.setItem('isJustLoggedIn', 'true')
    window.location.href = '/home'
  } catch (err) {
    errMessage.value = err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Something went wrong'
  } finally {
    loading.value = false
  }
}
</script>
